import React from "react";
import { TextField, Grid, Button, Typography, MenuItem, IconButton } from "@mui/material";
import { Add, Close } from "@mui/icons-material";

export default function EspecesForm(props) {
    const pieces = [500,200,100,50,20,10,5,2,1,0.5,0.2,0.1,0.05,0.02,0.01]

    return(
        <Grid container columnSpacing={2} rowSpacing={2} >
            {props.repartition.map((piece, index) =>
            <Grid item sm={6} key={index}>
                <Grid container key={index} columnSpacing={1}>
                    {props.repartition.length>1 && <Grid item sm={1.5}>
                        <IconButton 
                        aria-label="supprimer"
                        sx={{padding:0}} 
                        onClick={()=>{
                            props.setReptotal(old => old-(Number(props.repartition[index].montant)*props.repartition[index].count))
                            props.setRepartition(old => old.slice(0, index).concat(old.slice(index+1)))
                        }}>
                            <Close/>
                        </IconButton>
                    </Grid>}
                    <Grid item sm={5.5}>
                        <TextField
                        fullWidth
                        select
                        label='monnaie'
                        value={piece.montant}
                        onChange={(e)=> {
                            props.setReptotal(old => old-Number(props.repartition[index].montant)*props.repartition[index].count+Number(e.target.value))
                            props.setRepartition(old => old.slice(0, index).concat([{montant: Number(e.target.value), count:1}].concat(old.slice(index+1))))
                        }}>
                            {pieces.map((label, index) => (
                                <MenuItem key={index} value={label} disabled={(props.repartition.some(off=> off.montant === label) || (label>(Math.round((props.total - props.reptotal) * 100) / 100) && label>piece.montant)) && label!==piece.montant}>
                                    <Typography>{label.toFixed(2)} €</Typography> 
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                    <Grid item sm={5}>
                        <TextField
                        fullWidth
                        disabled={!Number(piece.montant)>0}
                        label="quantité"
                        InputLabelProps={{shrink: true}}
                        inputProps={{step:"1", min:'0'}}
                        type="number"
                        value={piece.count}
                        onChange={(e)=>{if (/^\d/.test(e.target.value)&&Number(e.target.value)>=0&&(Math.round((props.reptotal-(Number(props.repartition[index].montant)*props.repartition[index].count)+Number(props.repartition[index].montant)*parseInt(e.target.value))*100)/100)<=props.total){
                            props.setReptotal(old => Number(old-(Number(props.repartition[index].montant)*props.repartition[index].count)+Number(props.repartition[index].montant)*parseInt(e.target.value)))
                            props.setRepartition(old => old.slice(0, index).concat([{montant: old[index].montant, count:parseInt(e.target.value)}].concat(old.slice(index+1))))
                        }else if(e.target.value===''){
                            props.setReptotal(old => Number(old-(Number(props.repartition[index].montant)*props.repartition[index].count)))
                            props.setRepartition(old => old.slice(0, index).concat([{montant: old[index].montant, count:''}].concat(old.slice(index+1))))
                        }}}/>
                    </Grid>
                </Grid> 
            </Grid>)}
            {props.repartition[props.repartition.length-1].montant!=='' && props.repartition[props.repartition.length-1].count>0 && pieces.length>props.repartition.length && props.total>props.reptotal &&
            pieces.filter(label => props.repartition.filter(off=> off.montant === label).length<1 && label<=(Math.round((props.total-props.reptotal)*100)/100)).length>0 &&
            <Grid item sm={1}>
                <Button aria-label="ajouter" 
                variant="contained" 
                color="primary" 
                fullWidth
                sx={{paddingX:0, width:'100%'}}
                onClick={()=> props.setRepartition(old => old.concat([{montant: '', count:0}]))}>
                    <Add sx={{margin:0}}/>
                </Button>
            </Grid>}
        </Grid>
    )
}